import React from 'react';
import AppScreeningQuestion from './components';
import Layout from '../../layouts/index';

const ScreeningQuestion = () => {
    return (
        <Layout>
            <AppScreeningQuestion />
        </Layout>
    );
};

export default ScreeningQuestion;
